import type { FaireProductEntity } from "../../entity_types/product";

export const p_c2yynn24p5: FaireProductEntity = {
  token: "p_c2yynn24p5",
  type: "product",
  name: "The Polar Express Snow Globe",
  brandToken: "b_bomzcs63",
  brandName: "Hachette Book Group",
  imageUrl: "https://cdn.faire.com/fastly/ff8f294e3f0d9b051ce5b90b3b2968a6abf40ed10f7faeaa0bf431bed367524a.jpeg",
  galleryImageUrls: [],
  priceDollars: 8.48,
  description: "Bring some cheer to the holiday season with this officially licensed, palm-sized (3 x 3 x 1-1/2 inch) snow globe celebrating the classic film, The Polar Express, featuring swirling golden tickets! An approximately 3-inch snow globe with gold accents—featuring an image of the iconic film poster on one side and the note from Santa on the other. When swished around, the globe fills with tiny golden ticket \"snowflakes\" adding a magical and unique element to the snow globe. Includes a mini spiral-bound stand-up calendar (2 x 3-inch) filled with images and quotes that counts down the days until Christmas. This is an ideal gift or self-purchase for fans of The Polar Express. Authentic The Polar Express collectible.",
  tags: [],
  msrpDollars: 16.95,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:06:21.399Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
